import manifest from "./imageManifest.json";

/**
 * Return manifest entry for a given src (path relative to /src, e.g. "assets/banner-bg2.jpg")
 */
export function getOptimizedSources(src) {
  const key = src.startsWith("src/") ? src : `src/${src}`;
  const item = manifest[key];
  if (!item) return { base: "", sizes: [] };
  return { base: item.base, sizes: item.sizes };
}

/**
 * Build a srcset string; ensure URLs are safely encoded.
 */
export function buildSrcSets(base, sizes, ext) {
  return sizes
    .map((w) => `${encodeURI(`${base}-${w}.${ext}`)} ${w}w`)
    .join(", ");
}
